import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import MapGeoSideBar from '@/components/sidebar/MapGeoSideBar'
import HForm from '@/views/maps/history/HForm'
import CamStreamContainer from '@/utils/cam/CamStreamContainer.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('map-geo-side-bar', MapGeoSideBar)
Vue.component('h-form', HForm)
Vue.component('cam-stream-container', CamStreamContainer)


